"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SaveToPlaylistDropdown = void 0;

var _ = require("../..");

require("./SaveToPlaylistDropdown.css");

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Save To Playlist Dropdown
var SaveToPlaylistDropdown = function SaveToPlaylistDropdown(_ref) {
  var onClose = _ref.onClose,
      maxHeight = _ref.maxHeight,
      offsetAxisX = _ref.offsetAxisX,
      offsetAxisY = _ref.offsetAxisY,
      loggedInUser = _ref.loggedInUser,
      forceLoading = _ref.forceLoading,
      hideCloseButton = _ref.hideCloseButton,
      playlistsByUsers = _ref.playlistsByUsers,
      explicitAnchorRef = _ref.explicitAnchorRef,
      onDidSelectPlaylist = _ref.onDidSelectPlaylist,
      onDidRequestLockedPlaylist = _ref.onDidRequestLockedPlaylist,
      onDidRequestCreateNewPlaylist = _ref.onDidRequestCreateNewPlaylist,
      onDidRequestRelationLockedPlaylist = _ref.onDidRequestRelationLockedPlaylist;

  var _useState = (0, _react.useState)("save"),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var handleOnClose = function handleOnClose() {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  var handleOnBackClick = function handleOnBackClick() {
    if (step === "create") {
      setStep("save");
    } else {
      handleOnClose();
    }
  };

  var handleOnDidSelectPlaylist = function handleOnDidSelectPlaylist(playlist, userProfile) {
    if (typeof onDidSelectPlaylist === "function") {
      onDidSelectPlaylist(playlist, userProfile);
    }
  };

  var handleOnDidRequestCreateNewPlaylist = function handleOnDidRequestCreateNewPlaylist(options) {
    if (typeof onDidRequestCreateNewPlaylist === "function") {
      onDidRequestCreateNewPlaylist(options);
    }
  };

  var handleOnDidRequestLockedPlaylist = function handleOnDidRequestLockedPlaylist(playlist, userProfile) {
    if (typeof onDidRequestLockedPlaylist === "function") {
      onDidRequestLockedPlaylist(playlist, userProfile);
    }
  };

  var handleOnDidRequestRelationLockedPlaylist = function handleOnDidRequestRelationLockedPlaylist(playlist, userProfile) {
    if (typeof onDidRequestRelationLockedPlaylist === "function") {
      onDidRequestRelationLockedPlaylist(playlist, userProfile);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_.DropdownMenu, {
    title: "Save to Playlist",
    menuPortal: "#modal-root",
    className: "SaveToPlaylistDropdown",
    classNameMenu: "dropdown",
    menuDirection: "top",
    offsetAxisX: offsetAxisX,
    offsetAxisY: offsetAxisY,
    explicitAnchorRef: explicitAnchorRef,
    useMenuItems: false
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "content",
    style: {
      maxHeight: maxHeight
    }
  }, /*#__PURE__*/_react.default.createElement(_.StepController, {
    step: step
  }, /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "save"
  }, /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    className: "header save",
    onCloseClick: handleOnClose,
    hideCloseButton: hideCloseButton
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    content: "Save to Trace iD",
    type: _.Label.Type.Heading4
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.PlaylistSelector, {
    forceLoading: forceLoading,
    loggedInUser: loggedInUser,
    playlistsByUsers: playlistsByUsers,
    onDidSelectPlaylist: handleOnDidSelectPlaylist,
    onDidRequestLockedPlaylist: handleOnDidRequestLockedPlaylist,
    onDidRequestRelationLockedPlaylist: handleOnDidRequestRelationLockedPlaylist,
    onDidRequestCreateNewPlaylist: function onDidRequestCreateNewPlaylist() {
      return setStep("create");
    }
  }))), /*#__PURE__*/_react.default.createElement(_.Step, {
    name: "create"
  }, /*#__PURE__*/_react.default.createElement(_.TitleSection, {
    className: "header create",
    onCloseClick: handleOnClose,
    onBackClick: handleOnBackClick,
    hideCloseButton: hideCloseButton
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    content: "Create playlist",
    type: _.Label.Type.Heading4
  })), /*#__PURE__*/_react.default.createElement(_.ContentSection, null, /*#__PURE__*/_react.default.createElement(_.PlaylistCreator, {
    forceLoading: forceLoading,
    onDidRequestCreateNewPlaylist: handleOnDidRequestCreateNewPlaylist
  }))))));
};

exports.SaveToPlaylistDropdown = SaveToPlaylistDropdown;
SaveToPlaylistDropdown.defaultProps = {
  maxHeight: "none",
  hideCloseButton: false
};